module.exports = __webpack_public_path__ + "img/top-bg.acfa4b4e.png";